import { Translatable } from 'Shared/TranslatableTextContent/translatable'

export type QuestionTranslatableKeysBase = 'name'
export const questionTranslatablesBase: Record<QuestionTranslatableKeysBase, Translatable> = {
    name: {
        label: 'Label',
    },
} as const


export type QuestionTranslatableKeysName = 'firstNamePlaceholder' | 'lastNamePlaceholder' |QuestionTranslatableKeysBase
export const questionTranslatablesName: Record<QuestionTranslatableKeysName, Translatable> = {
    ...questionTranslatablesBase,
    firstNamePlaceholder: {
        label: 'First Name Placeholder',
        default: 'First name',
    },
    lastNamePlaceholder: {
        label: 'Last Name Placeholder',
        default: 'Last name',
    }
} as const

export type QuestionTranslatableKeysOptIn = 'yesLabel' | 'noLabel' | 'optOutMessage' | 'optOutTitle' | QuestionTranslatableKeysBase
export const questionTranslatablesOptIn: Record<QuestionTranslatableKeysOptIn, Translatable> = {
    ...questionTranslatablesBase,
    yesLabel: {
        label: 'Yes Label',
        default: 'Yes',
    },
    noLabel: {
        label: 'No Label',
        default: 'No',
    },
    optOutTitle: {
        label: 'Opt-Out Title',
        default: 'Are you sure?',
    },
    optOutMessage: {
        label: 'Opt-Out Message',
    },
} as const

export type QuestionTranslatableKeysScore = 'scoreLabelLeft' | 'scoreLabelRight' | QuestionTranslatableKeysBase
export const questionTranslatablesScore: Record<QuestionTranslatableKeysScore, Translatable> = {
    ...questionTranslatablesBase,
    scoreLabelLeft: {
        label: 'Low Score Label',
    },
    scoreLabelRight: {
        label: 'High Score Label',
    },
} as const

export type QuestionTranslatableKeysResponseConfirmation = 'responseConfirmMessage' | 'noAnswerProvidedMessage' | QuestionTranslatableKeysBase
export const questionTranslatablesResponseConfirmation: Record<QuestionTranslatableKeysResponseConfirmation, Translatable> = {
    ...questionTranslatablesBase,
    responseConfirmMessage: {
        label: 'Response Confirmation Message',
        default: 'I confirm that my answers are correct',
    },
    noAnswerProvidedMessage: {
        label: 'No Answer Provided Message',
        default: 'No answer provided',
    }
} as const

export type QuestionTranslatableKeys = QuestionTranslatableKeysBase | QuestionTranslatableKeysName | QuestionTranslatableKeysOptIn | QuestionTranslatableKeysScore | QuestionTranslatableKeysResponseConfirmation
export const questionTranslatables: Record<QuestionTranslatableKeys, Translatable> = {
    ...questionTranslatablesBase,
    ...questionTranslatablesName,
    ...questionTranslatablesOptIn,
    ...questionTranslatablesScore,
    ...questionTranslatablesResponseConfirmation,
} as const


export type AnswerTranslatableKeys = 'answer'
export const answerTranslatables: Record<AnswerTranslatableKeys, Translatable> = {
    answer: {
        label: 'Answer',
    },
} as const

